var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-button',{staticClass:"login-btn",attrs:{"type":"is-primary","icon-pack":"fab","icon-left":"google"},on:{"click":_vm.login}},[_vm._v(" Login ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }